import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const token = localStorage.getItem(
    `${process.env.REACT_APP_PREFIX}_access_token`
  );
  return token ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
